import axios from 'axios'
import endpoints from '../../endpoints'
import {TransportAdminBase, TransportAdminCreatePayload, TransportAdminUpdatePayload} from './type'
import {APIResponse} from '../../../types/type'

const API_URL = process.env.REACT_APP_API_URL || ''

export async function fetchTransportList(): Promise<APIResponse<TransportAdminBase[]>> {
  const response = await axios.get(API_URL + endpoints.transportAdmin.list)
  return response.data
}

export async function createTransport(
  body: TransportAdminCreatePayload
): Promise<APIResponse<null>> {
  const response = await axios.post(API_URL + endpoints.transportAdmin.create, body)
  return response.data
}

export async function updateTransport(
  body: TransportAdminUpdatePayload
): Promise<APIResponse<null>> {
  const response = await axios.post(API_URL + endpoints.transportAdmin.update, body)
  return response.data
}

export async function deleteTransport(securityId: string | number): Promise<APIResponse<null>> {
  const response = await axios.get(API_URL + endpoints.transportAdmin.delete + securityId)
  return response.data
}
